import React, { createContext } from "react";
export var ThemePortalContext = createContext(void 0);
export var ThemePortalProvider = function (props) {
  return React.createElement(ThemePortalContext.Provider, {
    value: props.themePortalTarget
  }, props.children);
};
ThemePortalProvider.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "ThemePortalProvider",
  props: {
    themePortalTarget: {
      required: !1,
      tsType: {
        name: "string"
      },
      description: ""
    },
    children: {
      required: !1,
      tsType: {
        name: "ReactReactNode",
        raw: "React.ReactNode"
      },
      description: ""
    }
  }
}, ThemePortalProvider.__docgenInfo = {
  componentName: "ThemePortalProvider",
  packageName: "@jutro/theme",
  description: "",
  displayName: "ThemePortalProvider",
  methods: [],
  actualName: "ThemePortalProvider"
};